module.exports = __webpack_public_path__ + "static/img/singleService-img.1d58ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeatures/singleService-img.png
// module id = jZM8
// module chunks = 0